import { createFileRoute, Link } from '@tanstack/react-router'
import SecuritySettings from '@/pages/settings/security'
import { Button } from '@deepguide-ai/ui/button'
import { ArrowLeft } from 'lucide-react'

export const Route = createFileRoute('/(protected)/auditor-center/security')({
  component: () => (
    <div className='px-6 py-8'>
      <Button variant='ghost' size='sm' asChild className='mb-6'>
        <Link to='/auditor-center'>
          <ArrowLeft className='h-4 w-4' />
          Audits
        </Link>
      </Button>
      <SecuritySettings />
    </div>
  ),
})
